export class Member {
  relationship: string;
  gender: string;
  tobaccoUse: string;
  dob: string;
}
